import React, { useState, useEffect } from 'react';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import 'rc-datepicker/lib/style.css';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { Pagination } from '../../Res/Pagination';
import { ContentBox } from '../../Content/ContentBox';
import { api_getCategoryList } from '../../../../api/apiCategory';
import { ReqCategoryList, RespCategoryItem } from '../../../../item/ItemCategory';
import { uuid } from '../../../../item/ItemTools';
import { setResume2Token } from '../../../Login/Auth';

export function CategoryList({ type, setIsLoading }) {
    const [categoryList, setCategoryList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)


    useEffect(() => {
        toSearch({ page: 1 })
    }, [])

    // useEffect(()=>{
    //     if(Object.keys(mReqEmployeeResumeList).length !== 0){
    //         toSearch({items: mReqEmployeeResumeList})
    //     }
    // },[mReqEmployeeResumeList])

    function toSearch({ page = 1 }) {
        //console.log("toSearch")
        var start = (page - 1) * limit;
        setPage(page)
        var mReqCategoryList = new ReqCategoryList({ start, limit, type })
        getCategoryList(mReqCategoryList)
    }


    async function getCategoryList(mReqCategoryList) {
        // console.log(mReqCategoryList)
        setIsLoading(true)
        api_getCategoryList({
            mReqCategoryList,
            success: (obj) => {
                //console.log(obj)
                var list = []
                obj.list.map(item => {
                    var mRespCategoryItem = new RespCategoryItem()
                    mRespCategoryItem.fromJson(item)
                    list.push(mRespCategoryItem)
                })
                // console.log(list)
                setCategoryList(list)
                setCount(obj.count)
                setIsLoading(false)
            },
            failure: (err) => {
                //console.log(err)
                setIsLoading(false)
            }
        })
    }

    function toAdd() {
        window.location.assign("/"+type+"CategoryAdd");
    }


    var baseTitle = "類別列表"
    var baseContent =
        <>
            <div className="row m-b-sm">
            </div>
            <ListBox categoryList={categoryList} count={count} page={page} sp={toSearch} type={type} />
        </>

    var title_tools =
        <a className="dropdown-toggle " data-toggle="dropdown" href="#A" onClick={e => toAdd()}>
            <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">新增</span>
        </a>

    return (
        <>
            <ContentBox title={baseTitle} title_tools={title_tools} content={baseContent} hasDrawer={false} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}


function ListBox({ categoryList, count, page, sp, type }) {
    const [mCategoryList, setCategoryList] = useState([])
    const [tableList, setTableList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        if (categoryList !== undefined && mCategoryList !== categoryList) {
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + mCategoryList.length)
            setCategoryList(categoryList)
            setTableList(setTable(categoryList))
            setPage(page)
        }

    }, [categoryList])

    useEffect(() => {
        if (count !== mCount) {
            setCount(count)
        }
    }, [count])

    function setTable(categoryList) {
        var list = []
        for (var i = 0; i < limit; i++) {
            if (categoryList[i] !== undefined) {
                list.push(<CategoryBox key={categoryList[i].categoryId} item={categoryList[i]} type={type} />)
            } else {
                list.push(<CategoryBox key={"resumeId" + i} />)
            }
        }
        return list
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (tableList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-3">名稱</th>
                                    <th className="text-center sorting col-sm-1">數量</th>
                                    <th className="text-center sorting col-sm-8">頁面</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    tableList.map((item) => (
                                        item
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function CategoryBox({ item, type }) {
    const [mCategory, setCategory] = useState({})
    const [categoryName, setCategoryName] = useState("")
    const [categoryId, setCategoryId] = useState("")
    const [count, setCount] = useState("")
    const [items, setItems] = useState([])

    useEffect(() => {
        // console.log(item)
        if (item !== undefined && item !== mCategory) {
            //console.log(department)
            setCategory(item)
            setCategoryName(item.categoryName)
            setCategoryId(item.categoryId)
            setCount(item.count)
            setItems(item.items)
        }
    }, [item])

    function toEdit(){
        var tokenId = uuid(128, 64)
        setResume2Token(categoryId, tokenId)
        window.location.replace("/"+type+"CategoryEdit/"+tokenId);
    }

    return (
        <tr role="row">
            <td className="text-center"><a href="#A" onClick={e=>toEdit()}>{categoryName}&nbsp;</a></td>
            <td className="text-center">{count}</td>
            <td className="text-center">
                <div className="row">
                    <div className="col-sm-12">
                {
                    items.map(item =>
                        (
                            <div key={item[type.toLowerCase()+"Id"]} className="col-sm-4">
                                {item[type.toLowerCase()+"Name"]}
                            </div>
                        )
                    )
                }
                </div>
            </div>
            </td>
        </tr>
    )
}
